export function toFixedDown(val, digits) {
    const re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)");
    const m = val.toString().match(re);
    return m ? parseFloat(m[1]) : parseFloat(String(val.valueOf()));
}

export function removeNan(val) {
    if (isNaN(val)) {
        return 0;
    }
    return val;
}

export function stripDecimals(n) {
    return removeNan(n) || 0;
}

export const stripNegative = (val) => {
    return Math.abs(val);
};

export function toFixedRound(val, digits) {
    const re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)");
    const m = val.toString().match(re);
    return m ? stripDecimals(m[1]) : stripDecimals(String(val.valueOf()));
}

export function formatCount(x) {
    return (x) ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : x;
};

export function convertNumStringToNum(stringAmount) {
    if (!stringAmount) return 0;

    const withoutComma = stringAmount.replace(/,/g, "");

    // 2. Convert the string to a floating-point number
    return parseFloat(withoutComma);

    // If you specifically need an integer (and are okay with losing the decimal part):
    // const integerAmount = parseInt(withoutComma);
    // console.log(integerAmount); // Output: 4999
    // console.log(typeof integerAmount); // Output: number
}